import './index.scss';

import myData from '../../db.json';

const HIGHLIGHT_GROUPS = [
  {
    className: 'intro-highlight',
    phrases: [
      '육아크루',
      'MAU 13만 명 규모의 성장 과정',
      '세시간전',
      '배포, 인프라, 데이터, 테스트 구조를 표준화·자동화',
      '제휴사마다 다른 판매/정산 스키마를 공통 구조로 통합',
      '제품을 만드는 방식과 개선하는 방식까지 함께 설계',
    ],
  },
];

const HIGHLIGHT_TOKENS = HIGHLIGHT_GROUPS.flatMap(({ className, phrases }) =>
  phrases.map((phrase) => ({ phrase, className }))
).sort((a, b) => b.phrase.length - a.phrase.length);

const getMatchedToken = (text, cursor) => {
  for (const token of HIGHLIGHT_TOKENS) {
    if (text.startsWith(token.phrase, cursor)) {
      return token;
    }
  }

  return null;
};

const getNextMatchIndex = (text, cursor) => {
  let closestIndex = -1;

  for (const token of HIGHLIGHT_TOKENS) {
    const foundIndex = text.indexOf(token.phrase, cursor);

    if (foundIndex === -1) {
      continue;
    }

    closestIndex = closestIndex === -1 ? foundIndex : Math.min(closestIndex, foundIndex);
  }

  return closestIndex;
};

const renderWithHighlights = (text) => {
  if (!text) return text;

  const segments = [];
  let cursor = 0;

  while (cursor < text.length) {
    const matchedToken = getMatchedToken(text, cursor);

    if (matchedToken) {
      segments.push(
        <span
          key={`${matchedToken.phrase}-${cursor}`}
          className={matchedToken.className}
        >
          {matchedToken.phrase}
        </span>
      );
      cursor += matchedToken.phrase.length;
      continue;
    }

    const nextMatchIndex = getNextMatchIndex(text, cursor);

    const nextCursor = nextMatchIndex === -1 ? text.length : nextMatchIndex;
    const plainText = text.slice(cursor, nextCursor);

    if (plainText) {
      segments.push(plainText);
    }

    cursor = nextCursor;
  }

  return segments;
};

const Intro = () => {
  const { intro } = myData;
  const hasContacts = intro.contacts && intro.contacts.length > 0;
  const summaryTitleLines = Array.isArray(intro.summaryTitle) ? intro.summaryTitle : [intro.summaryTitle];

  return (
    <section className='intro-section'>
      <p className='section-label'>{intro.sectionLabel}</p>
      <div className='intro-layout'>
        <div className='intro-copy'>
          <p className='intro-lead'>{intro.lead}</p>
          <h1 className='intro-heading'>
            {intro.headlinePrefix && <span>{intro.headlinePrefix} </span>}
            <strong>{intro.headlineHighlight}</strong>
            <span>{intro.headlineSuffix}</span>
          </h1>
          <div className='profile-image profile-image--mobile'>
            <img src={intro.profileImage} alt='박상수 프로필 사진' />
          </div>
          <h2 className='intro-summary-title'>
            {summaryTitleLines.map((line) => (
              <span key={line} style={{ display: 'block' }}>
                {line}
              </span>
            ))}
          </h2>
          <div className='intro-summary'>
            {intro.summary.map((paragraph) => (
              <p key={paragraph}>{renderWithHighlights(paragraph)}</p>
            ))}
          </div>
        </div>

        <aside className={`intro-profile${hasContacts ? '' : ' intro-profile--image-only'}`}>
          <div className='profile-image profile-image--desktop'>
            <img src={intro.profileImage} alt='박상수 프로필 사진' />
          </div>
          {hasContacts && (
            <div className='contact-card'>
              <h3>Contact</h3>
              <dl>
                {intro.contacts.map(({ label, value, href }) => (
                  <div key={label} className='contact-row'>
                    <dt>{label}</dt>
                    <dd>
                      {href ? (
                        href.startsWith('http') ? (
                          <a href={href} target='_blank' rel='noreferrer noopener'>
                            {value}
                          </a>
                        ) : (
                          <a href={href}>{value}</a>
                        )
                      ) : (
                        value
                      )}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          )}
        </aside>
      </div>
    </section>
  );
};

export default Intro;
